import request from './request';
import type { tCurrency } from '@/types/index';

// 修改昵称
export const editNickname = ({ nickname, countryCode, phoneNumber, avatarUrl }: { nickname?: string, countryCode?: string, phoneNumber?: string, avatarUrl?: string }) =>
  request({
    url: '/carbon-auth/private/user/center/user/edit',
    method: 'POST',
    data: { nickname, countryCode, phoneNumber, avatarUrl }
  });


// 用户详情
export const getUserDetail = (times = 15000) =>
  request({
    url: '/carbon-auth/private/user/center/user/detail',
    method: 'GET',
  }, {
    skipTime: times
  });

// 获取钱包
export const getWallet = ({ currency }: { currency: tCurrency }) =>
  request({
    url: '/carbon-wallet/private/user/wallet/user/detail',
    method: 'GET',
    params: {
      currency
    }
  });

// 重置密码
export const resetPw = ({ originalPassword, newPassword }: { originalPassword: string, newPassword: string }) =>
  request({
    url: '/carbon-auth/private/user/center/reset/pwd',
    method: 'POST',
    data: {
      originalPassword,
      newPassword
    }
  });